export default "__VITE_ASSET__fd200a82__"